import React from 'react';
import { Button } from 'components';
import styled from 'styled-components';

const ActionBar: React.FC<{
  usersToUnassign: string[];
  onClear: () => void;
  onUnassign?: () => void;
}> = ({ usersToUnassign, onClear, onUnassign }) => {
  if (!usersToUnassign.length) return null;

  return (
    <FixedDiv>
      <FlexContainer>
        <ButtonContainer>
          {usersToUnassign.length} selected
          <Button type="link" onClick={onClear}>
            Clear Selection
          </Button>
        </ButtonContainer>

        <Button type="primary" onClick={onUnassign}>
          Unassign
        </Button>
      </FlexContainer>
    </FixedDiv>
  );
};

const FixedDiv = styled.div`
  position: fixed;
  bottom: 20px;
  width: 60%;

  border: 1px solid #f0f0f0;
  border-radius: 4px;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

const FlexContainer = styled.div`
  background: white;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
`;

export default ActionBar;
